import { createApp } from "vue";
import Calendar from "./calendar/CalendarApp.vue";

const container = document.getElementById("js-calendar");

const app = createApp(Calendar, {
  workgroups: JSON.parse(container.dataset.workgroups),
  retiredGroups: JSON.parse(container.dataset.retiredGroups),
  initialWorkgroup: container.dataset.initialWorkgroup,
  initialMonth: container.dataset.initialMonth,
  initialYear: container.dataset.initialYear,
});
app.mount(container);
